export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ACQ129"] = "acq-129";
  ExperimentKeys["ACQ130"] = "acqci-acq-130";
  ExperimentKeys["ACQ131"] = "acqci-acq-131";
  ExperimentKeys["BIAB004"] = "biab-004";
  ExperimentKeys["ACQ128"] = "acq-128";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';